<ng-container *ngIf="!isDeliveryConfirmation">
  <div *ngIf="deliveryCurrent" class="basket-confirm">

    <app-delivery-list
      [deliveryCurrent]="deliveryCurrent"
      [deliveryList]="deliveryList"
      [wars]="wars"
      (deliveryChange)="switchesDeliveryType($event)"
    />

    <div class="del-type">
      <div class="del-type-comment"
           [innerHTML]="deliveryCurrent.comment"
      ></div>

      <div *ngIf="!dropshipFilesRequired" class="del-type-dropship-comment">
        <div>ОБОВ‘ЯЗКОВО! Після оформлення замовлення прописати номер ТТН в замовленнях: Меню - замовлення - графа номер
          декларації - буде виділена рожевим кольором.
        </div>
      </div>
      <!-- Нова схема (картка #868): номер ТТН система читає з наклейки - клієнт його лише перевіряє -->
      <div *ngIf="dropshipFilesRequired" class="del-type-dropship-comment">
        <div>Номер ТТН і кількість місць система розпізнає з наклейки - перевірте розпізнаний номер. Якщо номер не
          розпізнався, впишіть його у формі або після оформлення в замовленнях: Меню - замовлення - графа номер декларації.
        </div>
      </div>

      <div class="del-type-dropship-btn">
        <div>
          <div>
            <button class="button" (click)="showDropshipInstruction()">Інструкція</button>
          </div>
        </div>
      </div>

      <div class="del-type-address">
        <label>Адреса одержувача або відділеня</label>
        <div class="del-type-dropship-input">
          <input
            #scrollInputRef
            type='text'
            placeholder='Пропишіть адресу одержувача або відділеня'
            autocomplete='off'
            [class.border-wrong]="wrongDropshipAddress"
            [(ngModel)]="lastAddress.city"
            (input)="inputAddress()"
          >
          <span class="status-error" *ngIf="wrongDropshipAddress">Введіть адресу доставки мінімум 10 символів</span>
        </div>
      </div>

      <div *ngIf="deliveryCurrent.working_details.will_be_transfer" class="del-type-date-limited">
        <div>
          Дати відправлення обмежені в зв'язку
          з переміщенням з іншого складу
        </div>
      </div>

      <div *ngIf="deliveryCurrent.allow_delivery_dates" class="del-type-date">
        <label>
          Дата відправлення
        </label>
        <div *ngIf="dozakazDate" class="del-type-date-container">
          <small>Дозамовлення на дату: {{ dozakazDate }}</small>
          <ng-container *ngIf="dozakazDate === ''">
            <label *ngIf="!deliveryCurrent.allow_delivery_dates" class="alert">
              По прибуттю товару
            </label>
          </ng-container>
        </div>
        <div *ngIf="!dozakazDate">
          <select
            #scrollInputRef
            [class.border-wrong]="wrongDeliveryDates"
            [(ngModel)]="deliveryDate"
            (change)="onUserChangeDeliveryDate()"
          >
            <option value="-1">
              Вкажіть дату відправлення
            </option>
            <option *ngFor="let date of deliveryCurrent.delivery_dates" [value]="date">
              {{ date }}
            </option>
          </select>
          <span class="status" [class.status-error]="wrongDeliveryDates">Вкажіть дату відправлення</span>
        </div>
      </div>

      <div *ngIf="separateOrders && deliveryCurrent?.delivery_dates_zak?.length" class="del-type-date">
        <label>
          Дата відправки переміщення з іншого складу
        </label>
        <div>
          <select
            [class.border-wrong]="wrongDeliverySeparate"
            [(ngModel)]="deliverySeparate"
            (change)="changingValueDeliverySeparate()"
          >
            <option value="-1">
              Вкажіть дату відправлення
            </option>
            <option *ngFor="let date of deliveryCurrent.delivery_dates_zak" [value]="date">
              {{ date }}
            </option>
          </select>
          <span *ngIf="wrongDeliverySeparate" class="status-error">Вкажіть дату відправлення</span>
        </div>
      </div>
      <span *ngIf="showMessageOtgrujaem" class="message-otgrujaem">Включено відвантаження без оплати</span>

      <div *ngIf="deliveryHoursList.length" class="del-type-date">
        <label>
          Час відправки
        </label>
        <div>
          <select [class.border-wrong]="wrongDeliveryHours"
                  [(ngModel)]="deliveryHours"
                  (change)="changingValueDeliveryHours()">
            <option value="-1">
              Виберіть час відправки
            </option>
            <option *ngFor="let hour of deliveryHoursList" [value]="hour">
              {{ hour }}:00
            </option>
          </select>
          <span class="status" [class.status-error]="wrongDeliveryHours">Виберіть час відправки</span>
        </div>
      </div>

      <div class="del-type-np-info-recipient-head">
        <h3>Інформація одержувача</h3>
      </div>
      <div class="del-type-np-info-recipient-lastname">
        <label>ПІБ одержувача</label>
        <div>
          <input
            type="text"
            name="last_name"
            placeholder="Прізвище ім'я по батькові одержувача"
            [class.border-wrong]="wrongFio"
            [(ngModel)]="fio"
            (input)="inputFio()"
          >
          <span class="status" [class.status-error]="wrongFio">Введіть ім"я, мінімум 5 символів</span>
        </div>
      </div>

      <div class="del-type-phone">
        <label>Телефон отримувача</label>
        <div>
          <input
            type="text"
            #phoneRef
            appPhoneMask
            [class.border-wrong]="wrongLastAddressPhone"
            [(ngModel)]="lastAddress.phone"
            (input)="inputLastAddressPhone()"
          >
          <span *ngIf="wrongLastAddressPhone" class="status-error">
            Введіть номер телефону
          </span>
        </div>
      </div>

      <!-- Нова схема дропшипу (картка #867): наклейка і реєстр замість листа на пошту -->
      <ng-container *ngIf="dropshipFilesRequired">
        <div class="del-type-np-info-recipient-head">
          <h3>Наклейка і реєстр</h3>
        </div>
        <div *ngFor="let kind of dropshipFileKinds" class="del-type-dropship-file del-type-dropship-file-upload">
          <label [for]="'dropship_file_' + kind">{{ dropshipFileTitles[kind] }}</label>
          <div>
            <!-- Картка #899: замість рідного поля файлу - кнопка в стилі проєкту, як у «Замовлення файлом» -->
            <div class="del-type-dropship-file-row">
              <input
                #dropshipFileInput
                type="file"
                class="file-input"
                [id]="'dropship_file_' + kind"
                accept=".pdf,.png,.jpg,.jpeg,application/pdf,image/png,image/jpeg"
                [disabled]="dropshipFiles[kind].uploading"
                (click)="dropshipFilePressed[kind] = true"
                (change)="onDropshipFileSelected(kind, $event)"
              >
              <!-- Клік по підпису-кнопці доходить до поля як click - звідти й анімація натискання, і з клавіатури теж -->
              <label
                class="button del-type-dropship-file-button"
                [for]="'dropship_file_' + kind"
                [class.border-wrong]="!!dropshipFiles[kind].error"
                [class.disabled]="dropshipFiles[kind].uploading"
                [class.is-pressed]="dropshipFilePressed[kind]"
                (animationend)="dropshipFilePressed[kind] = false"
              >{{ dropshipFiles[kind].id ? 'Замінити файл' : 'Обрати файл' }}</label>
              <span class="del-type-dropship-file-name" [class.is-empty]="!dropshipFileName(kind)">
                {{ dropshipFileName(kind) || 'Файл не обрано' }}
              </span>
            </div>
            <span *ngIf="dropshipFiles[kind].uploading" class="status-hint">Завантаження…</span>
            <!-- Ім'я файлу вже поруч із кнопкою «Замінити файл» - тут без повтору (картка #899) -->
            <span *ngIf="!dropshipFiles[kind].uploading && dropshipFiles[kind].id" class="status-hint">Завантажено.</span>
            <span *ngIf="dropshipFiles[kind].error" class="status-error">{{ dropshipFiles[kind].error }}</span>
            <!-- Картка #868: що розпізнано з наклейки і звірка місць з розрахунком -->
            <ng-container *ngIf="kind === 'label' && labelParse && dropshipFiles.label.id && !dropshipFiles.label.uploading">
              <span *ngIf="labelParse.status === 'ok'" class="status-hint">
                Розпізнано ТТН {{ labelParse.ttn }}<ng-container *ngIf="labelParse.places">, місць {{ labelParse.places }}</ng-container>.
                Перевірте розпізнаний номер.
              </span>
              <span *ngIf="labelParse.status !== 'ok'" class="status-error">
                Номер ТТН з наклейки не розпізнано - впишіть його нижче<ng-container *ngIf="labelParse.places"> (місць на наклейці: {{ labelParse.places }})</ng-container>.
              </span>
              <span *ngIf="dropshipPlacesMismatch" class="status-error">{{ dropshipPlacesMismatchText }}</span>
            </ng-container>
          </div>
        </div>
        <div *ngIf="labelTtnMissing" class="del-type-dropship-file">
          <label for="dropship_ttn">Номер ТТН</label>
          <div>
            <input
              id="dropship_ttn"
              type="text"
              inputmode="numeric"
              placeholder="Номер ТТН з наклейки"
              [class.border-wrong]="!!manualTtnError"
              [(ngModel)]="manualTtn"
              (input)="inputManualTtn()"
            >
            <span *ngIf="manualTtnError" class="status-error">{{ manualTtnError }}</span>
            <span *ngIf="!manualTtnError" class="status-hint">
              Можна вписати й після оформлення: Меню - замовлення - графа номер декларації.
            </span>
          </div>
        </div>
        <div class="del-type-dropship-comment">
          <div>PDF, PNG або JPG, до 5 МБ кожен файл.</div>
        </div>
      </ng-container>

      <div class="del-type-user-comment">
        <label>Коментар до замовлення</label>
        <div>
          <textarea [(ngModel)]="deliveryComment"></textarea>
        </div>
      </div>

      <div class="del-type-send">
        <a routerLink="/basket">Редагувати замовлення</a>
        <div class="del-type-send-button">
          <app-order-in-progress-message [show]="showOrderInProgressMessage"/>
          <span *ngIf="dropshipFilesMissing" class="status-delivery">
            Будь ласка, прикріпіть наклейку і реєстр для оформлення дропшипінг-замовлення
          </span>
          <span *ngIf="!dropshipFilesMissing && dropshipPlacesMismatch" class="status-delivery">{{ dropshipPlacesMismatchText }}</span>
          <button class="button" [disabled]="isSendingPayment || dropshipFilesMissing || dropshipPlacesMismatch" (click)="sendPayment()">Відправити</button>
        </div>
      </div>
    </div>
  </div>
</ng-container>

<app-modal-np-dropship-info [newScheme]="dropshipFilesRequired"/>

<app-message-delivery-dropshipping-confirm [newScheme]="dropshipFilesRequired"/>
